import { Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WidgetLoader } from 'datastake-daf/dist/components';
import ReactFlow, { ReactFlowProvider } from 'react-flow-renderer';
import Style from './style';
import { useNodes } from './hook';
import { StakeholderService } from '../../../../../../../services';

export default function Flow({
  focusScp,
  onChange,
  disabledIds = [],
  setDisabledIds = () => { },
  formValue = {},
  onChangeValue = () => { },
  value = [],
  loading,
  setLoading = () => { },
  setDisabledFooter = () => { },
}) {
  const { t } = useTranslation();
  const [data, setData] = useState();
  const [initChangeDone, setInitChangeDone] = useState(false);

  const {
    elements,
    onConnect,
    onElementsRemove,
    onLoad,
    initElements,
    focusSelected,
    setFocusSelected,
    visualizeSelected,
    setVisualizeSelected,
    reset,
  } = useNodes({
    data,
    disabledIds,
    setDisabledIds,
    formValue,
  });

  useEffect(() => {
    if (initChangeDone) {
      if (Array.isArray(initElements)) {
        const _new = initElements
          .filter((el) => el.type === 'node' && !disabledIds.includes(el.id))
          .map((el) => el.config.datastakeId);
        onChange(_new);
      }
    }
  }, [disabledIds, initElements]);

  useEffect(() => {
    setInitChangeDone(false);
  }, [focusScp]);

  useEffect(() => {
    if (!initChangeDone && initElements) {
      const _new = initElements
        .filter((el) => {
          if (el.type === 'node') {
            if ((value || []).length === 0) {
              return false;
            }
            return !(value || []).includes(el.config.datastakeId);
          }
          return false;
        })
        .map((el) => el.id);
      setDisabledIds(_new);
      setInitChangeDone(true);
    }
  }, [value, initElements])

  const _fetch = async () => {
    try {
      setLoading(true);
      setDisabledFooter(true);
      const res = await StakeholderService.getFlow(focusScp)
      setDisabledFooter(false);
      setData(res.data);
      reset();
      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    _fetch();
  }, [focusScp]);

  return (
    <Style>
      {loading && (
        <WidgetLoader background='#EDF6FE' />
      )}
      <ReactFlowProvider>
        <ReactFlow
          elements={elements.length ? elements : []}
          onElementsRemove={onElementsRemove}
          onConnect={onConnect}
          onLoad={onLoad}
          selectNodesOnDrag={false}
          draggable={false}
          nodesDraggable={false}
          nodesConnectable={false}
          onElementClick={(e) => {
            if (initElements && Array.isArray(initElements)) {
              if (e.currentTarget && e.currentTarget.getAttribute) {
                const id = e.currentTarget.getAttribute('data-id');
                const node = initElements.find((el) => el.id === id);
                if (node) {

                }
              }
            }
          }}
        >
        </ReactFlow>
      </ReactFlowProvider>
      <div className='actions'>
        <div className='action'>
          <Checkbox
            checked={visualizeSelected}
            onChange={(e) => {
              setVisualizeSelected(e.target.checked)
              onChangeValue('visualizeSelected', e.target.checked)
            }}
          />
          <div className='flex-c jus-c'>
            <label>
              {t('Visualise unselected subjects')}
            </label>
          </div>
        </div>
        <div className='action'>
          <Checkbox
            checked={focusSelected}
            onChange={(e) => {
              setFocusSelected(e.target.checked)
              onChangeValue('focusSelected', e.target.checked)
            }}
          />
          <div className='flex-c jus-c'>
            <label>
              {t('Focus')}
            </label>
          </div>
        </div>
      </div>
    </Style>
  )
}
